module.exports = __webpack_public_path__ + "img/Google.18e5bb6.webp";